import { mediaCards } from '@/mocks/homeData';

const imageUrls: string[] = [
  'https://readdy.ai/api/search-image?query=Japanese%20manga%20reading%20scene%20with%20warm%20lighting%2C%20cozy%20reading%20nook%20with%20comic%20books%20open%2C%20soft%20natural%20light%20through%20curtains%2C%20aesthetic%20and%20artistic%20composition%2C%20warm%20tones%2C%20editorial%20style%20with%20minimal%20background&width=800&height=500&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20on%20tablet%20screen%2C%20colorful%20vertical%20scroll%20comic%20display%2C%20modern%20cozy%20interior%20with%20warm%20ambient%20lighting%2C%20digital%20art%20aesthetic%2C%20clean%20minimal%20background%20with%20soft%20shadows&width=800&height=500&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20manhua%20art%20style%20illustration%20with%20ink%20wash%20painting%20aesthetic%2C%20traditional%20eastern%20elements%20blended%20with%20modern%20comic%20style%2C%20warm%20paper%20texture%20background%2C%20artistic%20editorial%20photography%2C%20soft%20diffused%20lighting&width=800&height=500&seq=media-03&orientation=landscape',
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">漫迷视界</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选漫画推荐与阅读指南，帮你发现更多好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaCards.map((card, i) => (
            <div key={i} className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-colors duration-200 group cursor-pointer">
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-secondary-100">
                <img
                  src={imageUrls[i]}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{card.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}